<template>
  <details-list>
    <slot name="pre"/>
    <detail-item
        :item-value="workOrder.service_display_name"
        item-label="Service"
        item-selenium="triage-service"
        selenium="triage-service-container"
    />
    <detail-item
        :item-value="workOrder.user.address.city"
        item-label="Location"
        item-selenium="triage-location"
        selenium="triage-location-container"
    />
    <detail-item
        v-for="lqq in workOrder.qualifying_qas"
        :key="lqq.short_question"
        :item-label="lqq.short_question"
        :item-value="lqq.answer"
    />
    <detail-item
        item-label="Notes"
        class="ITEM-FULL"
        item-selenium="triage-notes"
        selenium="triage-notes-container"
    >
      <template slot="value">
        <span v-if="this.workOrder.merchant_order_lines.length">
          <notes-with-url
              :merchantOrderLines= "this.workOrder.merchant_order_lines"
              :description= "this.workOrder.description"/>
        </span>
        <span v-else>{{ workOrderNotes }} </span>
      </template>
    </detail-item>
    <detail-item
        item-label="Photos"
        class="ITEM-FULL"
        selenium="triage-photos-container"
        item-selenium="triage-photos"
    >
      <template slot="value">
        <gallery
            v-if="hasImages"
            :files="attachments"
            class="fw-wrap"
            selenium="file-upload-label" />
        <template v-else>(not provided)</template>
      </template>
    </detail-item>
    <slot name="post"/>
  </details-list>
</template>

<script>
import workOrder from '@/mixins/work-order';
import DetailsList from '@/components/DetailsList';
import DetailItem from '@/components/DetailsList/DetailItem';
import NotesWithUrl from '@/components/NotesWithUrl';

export default {
  name: 'job-details',
  components: {
    DetailsList,
    DetailItem,
    NotesWithUrl,
  },
  mixins: [
    workOrder,
  ],
  props: {
    // Used by workOrder mixin
    jobId: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasImages () {
      return this.workOrder && this.workOrder.attachments && this.workOrder.attachments.length;
    },
    attachments () {
      return this.hasImages ? this.workOrder.attachments.map(
        ({ asset_path, asset_thumbnail_path }) =>
          ({ src: asset_path, thumbnail: asset_thumbnail_path || asset_path })
      ) : [];
    },
    workOrderNotes () {
      return this.workOrder.description || '(not provided)';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";
  @import "../DetailsList/constants.scss";

  .ITEM-FULL {
    @include desktop {
      grid-column: length($desktop-columns) span;
    }
  }

</style>
